import styled from '@emotion/styled';
import theme from '@ep/theme';
import React from 'react';

export interface CollapsibleProps extends React.HTMLAttributes<HTMLDivElement> {
  height: string;
  collapsed: boolean;
}

const Divider = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.lightGray};
`;

const Wrapper = styled.div<CollapsibleProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: ${({ height, collapsed }) => (collapsed ? 0 : height)};
  overflow: hidden;
  transition: ${theme.transitions.create(['height'])};
`;

function Collapsible({ children, ...rest }: CollapsibleProps) {
  return (
    <Wrapper {...rest}>
      <Divider />
      {children}
    </Wrapper>
  );
}

export default Collapsible;
